import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import GenericHelmet from '../../components/genericHelmet/GenericHelmet'; // import your generic helmet
import 'bootstrap/dist/css/bootstrap.min.css';
import './landingPage.css';
import HuntHeader from '../../components/huntHeader/HuntHeader';

const GOAL = 300;

const LandingPage = () => {
  const [signups, setSignups] = useState(47);

  const spotsLeft = GOAL - signups;
  const percent = Math.round((signups / GOAL) * 100);

  // Handles form submit for all forms
  const handleOptIn = (e) => {
    // Allow the form to submit normally to AWeber
    // But also update the local state for all forms
    setSignups((prev) => (prev < GOAL ? prev + 1 : prev));
    // No preventDefault so AWeber still works
  };

  return (
    <>
      <>
        <GenericHelmet
          title="Trailblazer Challenge | Twin Trails Adventure – Camden & Paris, Tennessee"
          description="🚀 Join the Trailblazer Challenge in Camden & Paris, Tennessee — the ultimate treasure hunt! Explore local shops and trails, unlock clues, and win real prizes. Sign up today!"
          image="https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1664565843/Images/JOEGALAXYDopeGalaxyLogooriginal_tecmer.png"
          url="https://www.joegalaxy.net/trailblazer"
          regionName="Camden & Paris, Tennessee"
        />
      </>
      <div className="bg-dark min-vh-100 d-flex flex-column">
        <div className="w-100 text-center bg-primary bg-opacity-10 py-2">
          <div className="fw-bold fs-4 text-primary">
            Unlock Adventure: Be the First to Know When the Next Trailblazer
            Treasure Hunt Launches!
          </div>
          <div className="text-primary fs-5 fw-semibold">
            Sign up now to unlock clues, explore local trails, and win awesome
            prizes before anyone else!
          </div>
        </div>
        <header className="w-100 bg-gradient-custom shadow-sm py-3">
          <div className="container d-flex align-items-center justify-content-between">
            <HuntHeader title="JG Trailblazer Treasure Hunts" />

            <div style={{ minWidth: 320 }}>
              {/* Progress Bar */}
              <div className="w-100 mb-2" style={{ maxWidth: 500 }}>
                <div className="d-flex justify-content-between mb-1">
                  <span className="text-light small">
                    {signups}/{GOAL} spots claimed!
                  </span>
                  <span className="text-warning small">
                    Only {spotsLeft} left!
                  </span>
                </div>
                <div className="progress" style={{ height: 14 }}>
                  <div
                    className="progress-bar bg-warning"
                    role="progressbar"
                    style={{ width: `${percent}%` }}
                    aria-valuenow={signups}
                    aria-valuemin={0}
                    aria-valuemax={GOAL}
                  ></div>
                </div>
              </div>
              {/* Email Opt-in Form */}
              <form
                method="post"
                action="https://www.aweber.com/scripts/addlead.pl"
                className="row g-2 justify-content-center"
                onSubmit={handleOptIn}
              >
                <input
                  type="hidden"
                  name="meta_web_content_id"
                  value="f499cec9-7d55-49fc-904c-40f5f605fe19"
                />
                <input
                  type="hidden"
                  name="meta_web_form_id"
                  value="802038586"
                />
                <input type="hidden" name="meta_split_id" value="" />
                <input type="hidden" name="listname" value="awlist6893459" />
                <input type="hidden" name="redirect" value="" />
                <input type="hidden" name="meta_required" value="email" />
                <div className="col-12 col-md-7">
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="Enter your email"
                    className="form-control form-control-lg"
                  />
                </div>
                <div className="col-12 col-md-auto d-flex justify-content-center">
                  <button
                    type="submit"
                    className="btn btn-warning animated-subscribe-btn fw-bold px-4 py-2 rounded-pill"
                  >
                    Join the Hunt Now!
                  </button>
                </div>
              </form>
            </div>
            <p className="text-white-50 small mt-2 mb-0">
              We respect your privacy. No spam—unsubscribe anytime.
            </p>
          </div>
        </header>

        <main className="flex-grow-1">
          {/* Hero Section */}
          <section
            className="position-relative d-flex align-items-center justify-content-center text-center"
            style={{
              minHeight: '60vh',
              overflow: 'hidden',
            }}
          >
            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{
                background:
                  "url('https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1500&q=80') center center / cover no-repeat",
                opacity: 0.4,
                zIndex: 1,
              }}
            ></div>
            <div className="position-relative z-2 container d-flex flex-column align-items-center">
              <h1 className="display-3 fw-bold text-primary mb-3 text-shadow-custom">
                Twin Trails – Camden &amp; Paris, TN!
              </h1>
              <h2 className="fs-2 fw-semibold text-primary mb-3 text-shadow-custom">
                Unlock the Adventure—Be First to Know When the Hunt Begins!
              </h2>
              <p className="fs-4 mb-4 text-light">
                Get exclusive early access, secret clues, and a chance to win
                real prizes. Spots are limited!
              </p>
              {/* Progress Bar */}
              <div className="w-100 mb-3" style={{ maxWidth: 500 }}>
                <div className="d-flex justify-content-between mb-1">
                  <span className="text-light small">
                    {signups}/{GOAL} spots claimed!
                  </span>
                  <span className="text-warning small">
                    Only {spotsLeft} left!
                  </span>
                </div>
                <div className="progress" style={{ height: 14 }}>
                  <div
                    className="progress-bar bg-warning"
                    role="progressbar"
                    style={{ width: `${percent}%` }}
                    aria-valuenow={signups}
                    aria-valuemin={0}
                    aria-valuemax={GOAL}
                  ></div>
                </div>
              </div>
              {/* Email Opt-in Form */}
              <form
                method="post"
                action="https://www.aweber.com/scripts/addlead.pl"
                className="row g-2 justify-content-center mb-2"
                style={{ zIndex: 5 }}
                onSubmit={handleOptIn}
              >
                <input
                  type="hidden"
                  name="meta_web_content_id"
                  value="f499cec9-7d55-49fc-904c-40f5f605fe19"
                />
                <input
                  type="hidden"
                  name="meta_web_form_id"
                  value="802038586"
                />
                <input type="hidden" name="meta_split_id" value="" />
                <input type="hidden" name="listname" value="awlist6893459" />
                <input type="hidden" name="redirect" value="" />
                <input type="hidden" name="meta_required" value="email" />
                <div className="col-12 col-md-7">
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="Enter your email"
                    className="form-control form-control-lg"
                  />
                </div>
                <div className="col-12 col-md-auto">
                  <button
                    type="submit"
                    className="btn btn-warning animated-subscribe-btn fw-bold px-4 py-2 rounded-pill"
                    style={{ minWidth: 160 }}
                  >
                    Join the Hunt Now!
                  </button>
                </div>
              </form>
              <p className="text-white-50 small mt-2 mb-0">
                We respect your privacy. No spam—unsubscribe anytime.
              </p>
              <p className="text-warning fw-bold fs-3 mt-2">
                Only the first 100 explorers will get exclusive clues!
              </p>
              <p className="text-light fst-italic fs-4 mt-2">
                “I discovered new places and won awesome prizes!” — Sarah,
                Camden
              </p>
            </div>
          </section>

          {/* Promo Video */}
          <section className="py-4 bg-black text-center">
            <div className="container">
              <h2 className="fs-2 fw-bold mb-4 text-primary">
                🎬 Your Next Adventure Starts Here
              </h2>
              <div
                className="ratio ratio-16x9 rounded-4 border border-primary shadow mx-auto"
                style={{ maxWidth: 900 }}
              >
                <iframe
                  src="https://www.youtube.com/embed/qIgN-DAjqWA?si=eyXnrJ1DsSoZ4aY0?autoplay=1&loop=1&playlist=qIgN-DAjqWA"
                  title="Trailblazer Twin Trails Promo"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </section>

          {/* How It Works */}
          <section className="bg-dark py-5">
            <div className="container text-center">
              <h2 className="fs-2 fw-bold mb-5 text-primary">
                🗺️ How It Works
              </h2>
              <div className="row g-4">
                {[
                  {
                    title: '1. Register & Play',
                    desc: 'Sign up and get access to the local treasure map.',
                    icon: '📝',
                  },
                  {
                    title: '2. Explore & Unlock',
                    desc: 'Check in at shops and trails to reveal hidden clues.',
                    icon: '🧭',
                  },
                  {
                    title: '3. Share & Win',
                    desc: 'Post your journey and win real local prizes!',
                    icon: '🏆',
                  },
                ].map((step, idx) => (
                  <div className="col-12 col-md-4" key={idx}>
                    <div className="bg-secondary bg-opacity-75 rounded-4 shadow p-4 h-100 d-flex flex-column align-items-center">
                      <div className="fs-1 mb-3">{step.icon}</div>
                      <h3 className="fs-5 fw-semibold mb-2 text-warning">
                        {step.title}
                      </h3>
                      <p className="text-light">{step.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Testimonials */}
          <section className="bg-black py-5">
            <div className="container text-center">
              <h2 className="fs-2 fw-bold mb-4 text-primary">
                🎉 What Players Are Saying
              </h2>
              <div
                className="bg-secondary bg-opacity-75 rounded-4 shadow p-4 mx-auto"
                style={{ maxWidth: 600 }}
              >
                <blockquote className="fst-italic fs-5 text-light mb-0">
                  “This was the most fun I’ve had in my town in years. I
                  discovered new places and won awesome prizes!”
                </blockquote>
                <p className="mt-3 fw-semibold text-warning mb-0">
                  — Sarah, Camden
                </p>
              </div>
            </div>
          </section>

          {/* Final CTA / Email Opt-in */}
          <section
            id="signup"
            className="bg-gradient-custom py-5 text-center text-light"
            style={{
              background: 'linear-gradient(90deg, #4338ca 0%, #ec4899 100%)',
            }}
          >
            <div className="container" style={{ maxWidth: 600 }}>
              <h2 className="fs-1 fw-bold mb-3 text-warning">
                Get On The List!
              </h2>
              <p className="fs-4 mb-4">
                Be the first to know when the next Trailblazer Treasure Hunt
                launches.
                <br />
                <span className="fw-bold text-light">
                  Spots are limited—sign up now and don’t miss your adventure!
                </span>
              </p>
              {/* Progress Bar */}
              <div className="w-100 mb-3" style={{ maxWidth: 500 }}>
                <div className="d-flex justify-content-between mb-1">
                  <span className="text-light small">
                    {signups}/{GOAL} spots claimed!
                  </span>
                  <span className="text-warning small">
                    Only {spotsLeft} left!
                  </span>
                </div>
                <div className="progress" style={{ height: 14 }}>
                  <div
                    className="progress-bar bg-warning"
                    role="progressbar"
                    style={{ width: `${percent}%` }}
                    aria-valuenow={signups}
                    aria-valuemin={0}
                    aria-valuemax={GOAL}
                  ></div>
                </div>
              </div>
              {/* Email Opt-in Form */}
              <form
                method="post"
                action="https://www.aweber.com/scripts/addlead.pl"
                className="row g-2 justify-content-center"
                onSubmit={handleOptIn}
              >
                <input
                  type="hidden"
                  name="meta_web_content_id"
                  value="f499cec9-7d55-49fc-904c-40f5f605fe19"
                />
                <input
                  type="hidden"
                  name="meta_web_form_id"
                  value="802038586"
                />
                <input type="hidden" name="meta_split_id" value="" />
                <input type="hidden" name="listname" value="awlist6893459" />
                <input type="hidden" name="redirect" value="" />
                <input type="hidden" name="meta_required" value="email" />
                <div className="col-12 col-md-7">
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="Enter your email"
                    className="form-control form-control-lg"
                  />
                </div>
                <div className="col-12 col-md-auto">
                  <button
                    type="submit"
                    className="btn btn-warning animated-subscribe-btn fw-bold px-4 py-2 rounded-pill"
                  >
                    Join the Hunt Now!
                  </button>
                </div>
              </form>
              <p className="text-white-50 small mt-2 mb-0">
                We respect your privacy. No spam—unsubscribe anytime.
              </p>
            </div>
          </section>
        </main>

        {/* Footer */}
        <footer className="w-100 bg-dark border-top border-secondary mt-4">
          <div className="container py-4 d-flex flex-column flex-md-row align-items-center justify-content-between">
            <span className="text-secondary small text-center text-md-start">
              &copy; 2025 Trailblazer Challenge · All rights reserved · Camden
              &amp; Paris Edition
            </span>
            <span className="text-secondary small mt-2 mt-md-0 text-center text-md-end">
              Built with ❤️ for your adventure
            </span>
          </div>
        </footer>
      </div>
    </>
  );
};

export default LandingPage;
